/**
 * LifestyleStep.validation.js
 *
 * Pure function, no React — testable on its own and reusable if the
 * Summary screen (Screen 13) ever needs to re-validate before submit.
 * LifestyleStep only consumes `isValid` (to drive AssessmentStepShell's
 * `nextDisabled`, same as GoalStep does with `!selectedGoal`) — `errors`
 * is returned too in case a future screen wants field-level messaging.
 */

export function validateLifestyle(data) {
  const errors = {};

  if (!data.workType) errors.workType = "Please select your work type.";
  if (!data.wakeTime) errors.wakeTime = "Please select your wake-up time.";
  if (!data.sleepTime) errors.sleepTime = "Please select your sleep time.";
  if (data.waterIntake === null || data.waterIntake === undefined) {
    errors.waterIntake = "Please set your daily water intake.";
  }
  if (!data.stressLevel) errors.stressLevel = "Please select your stress level.";
  if (data.smoking !== "yes" && data.smoking !== "no") {
    errors.smoking = "Please let us know if you smoke.";
  }
  if (data.alcohol !== "yes" && data.alcohol !== "no") {
    errors.alcohol = "Please let us know if you drink alcohol.";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
